export const getInstitutions = (state) => state.institution?.institutions;
export const getOrgMembers = id => state => state.institution?.orgMembers[id];
export const getCurrentInstitution = (state) => state.institution?.currentInstitution;
export const isInstitutionLoading = (state) => state.institution?.loading;